import { getDefaultPieFormatting } from "@/containers/E4ImpactMBA/charts/pie";

const transformData = [
    'Bakery', 'Beverage', 'Cereals', 'Dairy', 'Gum', 'Fodder', 'Herbalism',
    'Seafood', 'Snacks', 'Sweets'
];

/**
 * question: What is your specialty?
 * == baseline
 * question4
 * 
 * @param props 
 * @returns 
 */
export const specialtyProcessingSectorChartCalculation = (props: any) => {    
    return getDefaultPieFormatting(
        'Specialty of the food processing sector',
        transformData.map((value) => ({
            name: value,
            y: props.baselineSubmissions.filter((submission: any) => {
                for (let i = 0; i < transformData.length; i++) {
                    if (submission[`question4_${i}`] === value) {
                        return true;
                    }
                }
                
                return false;
            }).length
        }))
    )
}